// The login token for requests that do NOT go through the shared axios client.
// Axios gets it from the interceptor in App.js; a plain fetch() has to add it itself.
// The server decides who is asking from this token, never from an id in the URL.
export function authHeaders(extra = {}) {
  let token = null;
  try {
    token = localStorage.getItem('sessionToken');
  } catch (_) { /* storage unavailable: send the request without a login */ }
  return token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra };
}
